import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ConnectionsPage } from "./pages/ConnectionsPage";
import { SystemStatusPage } from "./pages/SystemStatusPage";
import { shallowEqual, useSelector } from "react-redux";
import { QueryParamProvider } from 'use-query-params';

const CorePage = lazy(() =>
  import("./modules/Core/pages/CorePage")
);
const UserProfilepage = lazy(() =>
  //import("./modules/UserProfileOriginal/UserProfilePage")
  import("./modules/UserProfile/pages/UserProfilePage")
);

const InspetionPage = lazy(() =>
  import("./modules/Inspection/pages/InspectionPage")
);

const RundownPage = lazy(() =>
  import("./modules/Rundown/pages/RundownPage")
);
const FmsPage = lazy(() =>
  import("./modules/Fms/pages/FmsPage")
);
const LogsPage = lazy(() =>
  import("./modules/Logs/pages/LogsPage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  const { haveToChangePassword } = useSelector(
    ({ auth }) => ({
      haveToChangePassword: auth.user?.haveToChangePassword,
    }),
    shallowEqual
  );
  return (
    <>
      <QueryParamProvider ReactRouterRoute={Route}>
      <Suspense fallback={<LayoutSplashScreen />}>
          {!haveToChangePassword ? (
            <Switch>
              {
                /* Redirect from root URL to /dashboard. */
                < Redirect exact from="/" to="/dashboard" />
              }
              <Route path="/dashboard" component={DashboardPage} />
              <Route path="/connections" component={ConnectionsPage} />
              <Route path="/about" component={SystemStatusPage} />
              <ContentRoute path="/my-page" component={MyPage} />
              <Route path="/core" component={CorePage} />
              <Route path="/inspection" component={InspetionPage} />
              <Route path="/rundown" component={RundownPage} />
              <Route path="/fms" component={FmsPage} />
              <Route path="/user-profile" component={UserProfilepage} />
              <Route path="/logs" component={LogsPage} />
              <Redirect to="error/error500/error" />
            </Switch>
          ) : (
            <Switch>
              <Route path="/user-profile" component={UserProfilepage} />
              <Redirect to="/user-profile/change-password" />
            </Switch>
          )}

      </Suspense>
      </QueryParamProvider>
    </>
  );
}
